/*globals jQuery:false */
import IntersectionObserved from "./lib/intersection-observed.js";

const BEFORE_AFTER_TIMEOUT = 1000;
const BEFORE_AFTER_FADE_SPEED = 1000;

class FeaturedBeforeAfter extends IntersectionObserved {
	constructor(el) {
		super(el);

		this.dom = {
			el,
			before: el.querySelector(".featured-pages-grid__background--before"),
			after: el.querySelector(".featured-pages-grid__background--after"),
			backgrounds: el.querySelectorAll(".featured-pages-grid__background > div"),
		};

		// console.log("FeaturedBeforeAfter", this.dom);

		if (!this.dom.before || !this.dom.after || !this.dom.backgrounds) return;

		let transTimeout = parseInt(el.dataset.beforeAfterTimeout, 10);
		if (!transTimeout || isNaN(transTimeout)) {
			transTimeout = BEFORE_AFTER_TIMEOUT;
		}

		// console.log("transTimeout:", transTimeout);

		let transSpeed = parseInt(el.dataset.beforeAfterSpeed, 10);
		if (!transSpeed || isNaN(transSpeed)) {
			transSpeed = BEFORE_AFTER_FADE_SPEED;
		}

		// console.log("transSpeed:", transSpeed);

		this.transTimeout = transTimeout;
		this.transSpeed = transSpeed;

		//this.beforeAfterTimeouts = [];

		this.addBgLoadedListeners();

		this.beforeVisible = true;

		// start visibility listener
		this.initVisibilityCheck({
			//rootMargin: '-20%',
		});
	}

	// attempt to determine when our items' background images are loaded
	// ideally, the initial "to grid" anime won't run until all images are loaded
	addBgLoadedListeners() {
		let bg;

		const home = this;

		// flags
		this.allBgsLoaded = false;
		this.bgsToLoad = 0;
		this.bgsLoaded = 0;

		// loop the background elements and extract the image url
		// then add as src to new img el with load listener
		[...this.dom.backgrounds].forEach((el) => {
			bg = el.style.backgroundImage.slice(4, -1).replace(/['"]/g, "");

			if (bg) {
				this.bgsToLoad++;

				jQuery("<img/>")
					.attr("src", bg)
					.on("load", function () {
						jQuery(this).remove();

						home.bgsLoaded++;

						// console.log("bg " + home.bgsLoaded + " of " + home.bgsToLoad + " loaded");

						if (home.bgsLoaded >= home.bgsToLoad) {
							home.allBgsLoaded = true;
						}
					});
			}
		});

		if (this.bgsLoaded >= this.bgsToLoad) {
			this.allBgsLoaded = true;
		}
	}

	/**
	 * callback from intersection listener(s)
	 */
	onBecomeVisible() {
		// console.log("onBecomeVisible", this.allBgsLoaded);

		if (this.hasBecomeVisible) return;

		// set inited flag
		this.hasBecomeVisible = true;

		// if our items' bg images aren't loaded
		// check them again on an interval
		// if not loaded after x number checks, run anime anyway
		if (this.allBgsLoaded) {
			this.animateBeforeAfter();
		} else {
			this.bgChecks = 0;
			this.bgCheckID = setInterval(() => {
				// console.log("bgs loaded check", this.bgsLoaded, this.bgChecks);

				this.bgChecks++;

				if (this.allBgsLoaded || this.bgChecks > 5) {
					clearInterval(this.bgCheckID);
					this.animateBeforeAfter();
				}
			}, 200);
		}
	}

	animateBeforeAfter() {
		setTimeout(() => {
			//console.log('before after timeout fire!');

			if (this.beforeVisible) {
				jQuery(this.dom.before).fadeOut(this.transSpeed, () => {
					this.beforeVisible = false;
					this.animateBeforeAfter();
				});
			} else {
				jQuery(this.dom.before).fadeIn(this.transSpeed, () => {
					this.beforeVisible = true;
					this.animateBeforeAfter();
				});
			}
		}, this.transTimeout);
	}
}

jQuery(document).ready(function () {
	let i;

	let beforeAfterEls = document.querySelectorAll(".featured-pages-grid__element--is-before-after");

	for (i = 0; i < beforeAfterEls.length; i++) {
		new FeaturedBeforeAfter(beforeAfterEls[i]);
	}
});
